import { createRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { Mail, Send } from 'lucide-react'
import rootRoute from './rootRoute'
import { Button, Input, errorToast, toast } from '@/components/ui'
import AuthLayout from '@/components/layout/AuthLayout'
import { $client } from '@/lib/fetch'

const ForgotPasswordPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const [email, setEmail] = useState('')
  const navigate = useNavigate()

  const request = async () => {
    setIsLoading(true)
    const resp = await $client
      .POST('/api/auth/forgot-password', { body: { email } })
      .finally(() => setIsLoading(false))

    if (resp.error != null) {
      errorToast('Une erreur est survenue', resp.error)
    } else {
      setEmailSent(true)
      toast({
        color: 'success',
        title: 'Email envoyé ! Vérifiez votre boîte de réception.',
      })
    }
  }

  return (
    <AuthLayout
      panelTitle="Mot de passe oublié ?"
      panelSub="Pas de souci. Indiquez votre email et nous vous enverrons un lien de réinitialisation."
    >
      <h1 style={{ fontSize: 'var(--text-h2)', margin: '0 0 8px' }}>
        Réinitialiser
      </h1>
      {emailSent ? (
        <>
          <p
            style={{ fontSize: 15.5, color: 'var(--ink-2)', marginBottom: 24 }}
          >
            Consultez votre boîte de réception et suivez les instructions. Le
            lien expirera dans une heure.
          </p>
          <Button
            variant="secondary"
            onClick={() =>
              navigate({ to: '/login', search: { go: undefined } })
            }
          >
            Retour à la connexion
          </Button>
        </>
      ) : (
        <>
          <p
            style={{ fontSize: 15.5, color: 'var(--ink-2)', marginBottom: 28 }}
          >
            Entrez l'adresse e-mail associée à votre compte.
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              request()
            }}
            style={{ display: 'flex', flexDirection: 'column', gap: 18 }}
          >
            <Input
              label="Adresse e-mail"
              type="email"
              iconLeft={<Mail size={18} />}
              placeholder="vous@email.fr"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button
              variant="primary"
              size="lg"
              fullWidth
              type="submit"
              loading={isLoading}
              iconLeft={<Send size={18} />}
            >
              Envoyer le lien
            </Button>
          </form>
        </>
      )}
    </AuthLayout>
  )
}

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/forgot-password',
}).lazy(() => import('./ForgotPasswordPage.lazy').then((m) => m.Route))

export default ForgotPasswordPage
